export enum GraphGradientEnums {
  DEEPEST_BLUE = "#05182A",
  VERY_DARK_BLUE = "#0A2F54",
  EVEN_DARKER_BLUE = "#0F477E",
  DARKER_BLUE = "#145EA8",
  DEEPER_BLUE = "#1976D2",
  MEDIUM_BLUE = "#4791DB",
  MEDIUM_LIGHT_BLUE = "#75ADE4",
  LIGHTER_BLUE = "#A3C8ED",
  LIGHT_BLUE = "#D1E4F6",
  LIGHTEST_BLUE = "#DDEAF8",
  LINE_COLOR = "#1976D2",
}

/*
stops: [
        [0, '#05182A'],  // Deepest blue near the data point
        [0.1, "#0A2F54"], // Very dark blue
        [0.2, "#0F477E"], // Even darker blue
        [0.3, "#145EA8"], // Darker blue
        [0.4, "#1976D2"], // Deeper blue
        [0.5, "#4791DB"], // Medium blue
        [0.6, "#75ADE4"], // Medium light blue
        [0.7, "#A3C8ED"], // Lighter blue
        [0.8, "#D1E4F6"], // Light blue
        [1, "#DDEAF8"], // Lightest blue
      ],
*/
